/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignListItemResponseSchema,
  updateCampaignRequestSchema,
} from '../campaign-schema';

export const updateCampaignPathSchema = z.object({ campaignId: z.string() });

export const updateCampaignRequestBodySchema = updateCampaignRequestSchema;

export const updateCampaignOperationResponseSchema =
  campaignListItemResponseSchema;

export type UpdateCampaignInput = {
  path: z.input<typeof updateCampaignPathSchema>;
  body?: z.input<typeof updateCampaignRequestBodySchema>;
  signal?: AbortSignal;
};

export async function updateCampaign({
  path,
  body,
  signal,
}: UpdateCampaignInput): Promise<
  z.infer<typeof updateCampaignOperationResponseSchema>
> {
  const parsedPath = updateCampaignPathSchema.parse(path);
  const parsedBody =
    body === undefined
      ? undefined
      : updateCampaignRequestBodySchema.parse(body);

  const response = await socialApiClient.patch(
    `campaigns/${parsedPath.campaignId}`,
    {
      signal,
      ...(parsedBody === undefined ? {} : { json: parsedBody }),
    },
  );
  return updateCampaignOperationResponseSchema.parse(await response.json());
}
